module.exports = __webpack_public_path__ + "static/img/reward-bg.cb8eb535.webp";